module.exports = __webpack_public_path__ + "img/en.a0f21f7b.png";